import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogTitle, MatDialogContent } from '@angular/material/dialog';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import { SeccionEstimacionesSiniestroComponent } from '../seccion-estimaciones-siniestro/seccion-estimaciones-siniestro.component';
import { MatTabChangeEvent, MatTabGroup, MatTab, MatTabLabel } from '@angular/material/tabs';

import { catchError, combineLatest, map, Observable, of, Subscription, switchMap, throwError } from 'rxjs';
import { trigger, style, transition, animate, state } from '@angular/animations';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ConceptoFoto, ConsultaEstimacionesOutput, ConsultaSiniestroOutput, Fotografia, FotografiaError } from 'src/app/models/complementos-web/complementos-web.model';
import { selectDetalleSiniestroSiniestros, selectSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { ActivarLoadingAction, DesactivarLoadingAction, MostrarMensajeErrorAction } from 'src/app/@store/actions';
import { DocumentosSeccionComplementoComponent, EstadoTabDocumentos } from '../../@components/documentos-seccion-complemento/documentos-seccion-complemento.component';
import { HandlerDocumentumClass } from 'src/app/services/documentum/documentum-handler.service';
import { DocumentumService } from 'src/app/services/documentum/documentum.service';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { MatButton } from '@angular/material/button';
import { NoImagenPipe } from '../../@pipe/no-imagen.pipe';

export interface GaleriaItem {
  type: 'image' | 'video' | 'iframe';
  src: any;
  thumb?: string;
  poster?: string;
  alt?: string;

  autoplay?: boolean,
  controls?: boolean,
  mute?: boolean,
  loop?: boolean,
}

@Component({
    selector: 'app-seccion-fotografias',
    templateUrl: './seccion-fotografias.component.html',
    styleUrls: ['./seccion-fotografias.component.scss'],
    animations: [
        trigger('slideAnimation', [
            state('in', style({ transform: 'translateY(0)', opacity: 1 })),
            transition(':enter', [
                style({ transform: 'translateY(-70%)', opacity: 0 }),
                animate('400ms ease-in')
            ]),
            transition(':leave', [
                animate('400ms ease-in', style({ transform: 'translateY(-70%)', opacity: 0 }))
            ])
        ])
    ],
    imports: [MatDialogTitle, CdkScrollable, MatDialogContent, MatTabGroup, MatTab, MatTabLabel, DocumentosSeccionComplementoComponent, MatButton, NoImagenPipe]
})
export class SeccionFotografiasComponent extends HandlerDocumentumClass implements OnInit {

  @ViewChild('documentosSeccionComplemento') documentosSeccionComplemento: DocumentosSeccionComplementoComponent;

  protected override getArchivos(): any[] {
    return this.fotosTemporalesSeccion;
  }
  protected override setArchivos(archivos: any[]): void {
    this.fotosTemporalesSeccion = archivos;
  }

  public detalleSeccionSiniestroComplemento: ConsultaSiniestroOutput;
  public siniestroConsultado: string;
  public estimacionesSiniestro: ConsultaEstimacionesOutput;
  public listaObservables = new Subscription();

  public tabIndex: number = 0;
  public activeIndex = 0;
  public seccionesFotografias: ConceptoFoto[] = [];

  public fotosTemporalesSeccion = [];
  public documentoGenerales = [];

  constructor(
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<SeccionEstimacionesSiniestroComponent>,
    public override store: Store<AppState>,
    private complementoWebService: ComplementoWebService,
    public override documentumService: DocumentumService,
    private procesosComplementoService: ProcesosComunesComplementoService,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super(store, documentumService);
    this.obtenerReduxState();
  }

  ngOnDestroy() {
    this.listaObservables.unsubscribe();
  }

  obtenerReduxState() {
    const subsComplemento = combineLatest([
      this.store.select(selectSiniestroSiniestros),
      this.store.select(selectDetalleSiniestroSiniestros),
    ]).subscribe(([siniestro, detalleSiniestro]) => {
      this.detalleSeccionSiniestroComplemento = detalleSiniestro?.siniestroDetalle;
      this.siniestroConsultado = siniestro;
      this.consultarConceptosFotografias();
    });
    this.listaObservables.add(subsComplemento);
  }

  ngOnInit(): void {
  }

  closeDialog(opcion: string) {
    if (opcion == 'Cancelar') this.dialogRef.close();
    if (opcion == 'Aceptar') this.dialogRef.close();
  }

  onTabChange(event: MatTabChangeEvent) {
    this.tabIndex = Number(event.index + 1);
    this.activeIndex = 0;
    const datosTab = this.seccionesFotografias[this.tabIndex - 1];
    this.consultaFotografias(this.tabIndex - 1, datosTab.cve_docto, datosTab.Fotografias);
  }

  trackByTab(index: number, item) {
    return item.cve_docto;
  }

  prevArchivo() {
    if (this.activeIndex > 0) {
      this.activeIndex--;
    }
  }

  nextArchivo() {
    const datosTab = this.seccionesFotografias[this.tabIndex - 1];
    if (this.activeIndex < datosTab.Fotografias?.length - 1) {
      this.activeIndex++;
    }
  }

  consultaTodasFotografias(evento: Partial<EstadoTabDocumentos>) {
    this.consultarConceptosFotografias(true);
  }

  consultarConceptosFotografias(consultaFoto: boolean = false) {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestro: `${this.siniestroConsultado}`
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaConceptosXtenders(request).pipe(map(result => {
      let datos = result;
      if (result.Resultado.Conceptos != null) {
        const todasFotografias = result.Resultado.Conceptos.flatMap(x => x.Fotografias || []);
        datos.Resultado.Conceptos = result.Resultado.Conceptos.map(concepto => {
          concepto.Fotografias = [];
          concepto.Todo = todasFotografias;
          return concepto;
        });
      }
      return datos;
    })).subscribe({
      next: (value) => {
        if (value.Resultado.Conceptos != null) {
          this.seccionesFotografias = value.Resultado.Conceptos;
          if (consultaFoto) {
            let datosTab = this.seccionesFotografias[this.tabIndex - 1];
            this.consultaFotografias(this.tabIndex - 1, datosTab.cve_docto, datosTab.Fotografias);
          }
        } else {
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `No se encontró ninguna fotografía`, 'warning', false, true);
        }
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos obtener los datos de las reglas de ajuste.' }));
      },
    })
  }

  eliminarFotografia(fotografia: Fotografia) {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestro: `${this.siniestroConsultado}`,
      id: fotografia.rowid,
      nombre: fotografia?.nombre,
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.eliminaFotografia(request).pipe(
      switchMap(documento => {
        return this.eliminaArchivoDocumentum(fotografia).pipe(
          map(() => ({ ...documento, documentumOk: true })),
          catchError(err => {
            if (err.status === 401) {
              return throwError(() => err);
            }
            return of({ ...documento, documentumOk: false });
          })
        );
      })
    ).subscribe({
      next: (value) => {
        console.log(value)
        this.store.dispatch(DesactivarLoadingAction());
        if (value.documentumOk) {
          this.procesosComplementoService.alertaGeneralComplemento('Eliminado', `La fotografía fue eliminada correctamente.`, 'success', false, true);
        } else {
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', ` ${value.Mensaje || 'Error al eliminar la fotografía. No se encontró el archivo.'}`, 'warning', false, true);
        }
        if (value.Resultado != null) {
          this.consultarConceptosFotografias(true);
        }
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos terminar de eliminar la fotografía.' }));
      },
    })
  }

   consultaFotografias(indexTab: number, cveDocumento: number, fotografias: Fotografia[]) {
    if (indexTab < 0 || !this.seccionesFotografias[indexTab]) {
      return;
    }
    console.log(`[SeccionFotografias] Ejecutando consultaFotografias para tab ${indexTab}, cveDocumento: ${cveDocumento}`);
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestro: `${this.siniestroConsultado}`,
      documento: cveDocumento,
      cadenaRowId: fotografias.length ? fotografias.map(ft => ft.rowid).join(",") : '',
    }
    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.consultaFotografias(request).subscribe({
      next: (value) => {
        if (value.Resultado.Fotografias != null) {
          this.seccionesFotografias[indexTab].Fotografias = value.Resultado.Fotografias.map(ft => {
            return { ...ft, url: '' }
          });
          this.precargaDocumentosDetalleDocumentum(indexTab);
        }
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos terminar de eliminar la fotografía.' }));
      },
    })
  }

  getSafeUrl(url: string): SafeResourceUrl {
    return this.sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  obtenerType(nombreImagen: string) {
    if (!nombreImagen) return;
    const extension = nombreImagen?.split('.').pop()?.toLowerCase();

    const imageTypes = ['jpg', 'jpeg', 'png', 'gif', 'bmp'];
    const videoTypes = ['mp4', 'mov', 'avi', 'mkv', 'webm'];

    if ((extension && imageTypes.includes(extension))) {
      return 'imagen';
    }

    if ((extension && videoTypes.includes(extension))) {
      return 'video';
    }

    if (extension === 'pdf') {
      return 'pdf';
    }

    return 'otro';
  }

  obtenerSrcArchivo(archivo: Fotografia): string | null {
    if (!archivo) return null;
    const nombre = archivo.nombre?.toLowerCase() || '';
    const esBase64 = this.esBase64(archivo.fotografia);
    const ext = nombre.split('.').pop() || '';

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) {
      return !esBase64 ? archivo.fotografia : `data:image/${ext};base64,${archivo.fotografia}`;
    }

    if (['mp4', 'webm', 'ogg'].includes(ext)) {
      return esBase64
        ? `data:video/${ext};base64,${archivo.fotografia}`
        : archivo.fotografia || null;
    }

    if (ext === 'pdf') {
      return !esBase64 ? archivo.fotografia : `data:application/pdf;base64,${archivo.fotografia}`;
    }

    return archivo.fotografia || null;
  }

  obtenerSrcMiniaturaArchivo(archivo: Fotografia): string | null {
    if (!archivo) return null;
    const nombre = archivo.nombre?.toLowerCase() || '';
    const esBase64 = this.esBase64(archivo.fotografia);
    const ext = nombre.split('.').pop() || '';

    if (['jpg', 'jpeg', 'png', 'gif', 'bmp'].includes(ext)) {
      return !esBase64 ? archivo.fotografia : `data:image/${ext};base64,${archivo.fotografia}`;
    }

    if (['mp4', 'webm', 'ogg'].includes(ext)) {
      return esBase64
        ? `data:video/${ext};base64,${archivo.fotografia}`
        : archivo.fotografia || null;
    }

    if (ext === 'pdf') {
      return !esBase64 ? archivo.fotografia : `assets/img/complemento-web/pdf.png`;
    }

    return archivo.fotografia || null;
  }

  cargarPdf(fotografia: Fotografia) {
    const doc = fotografia;
    if (!doc || !doc.nombre?.includes('pdf')) return null;

    const base64 = doc.fotografia.includes(',')
      ? doc.fotografia.split(',')[1]
      : doc.fotografia;

    const byteCharacters = atob(base64);
    const byteNumbers = new Array(byteCharacters.length);

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    const blob = new Blob([new Uint8Array(byteNumbers)], {
      type: 'application/pdf'
    });
    return this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
  }

  esBase64(cadena: string): boolean {
    if (cadena == 'No_Disponible') return false;
    const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
    return base64Regex.test(cadena);
  }

  mostrarAdvertenciaArchivosPendientes(): void {
    const archivosEstatusCero = this.seccionesFotografias.filter(fotos => fotos.Fotografias.some(archivo => archivo.estatus == "0"));
    const hayArchivosPendientes = archivosEstatusCero.length;

    if (!hayArchivosPendientes) return;

    const html = `
      <p style="text-align: left;">
        Tiene archivos pendientes por guardar. <br><br>
        ¿Está seguro que quiere cancelar la operación y no guardar los archivos pendientes en <strong>Extender</strong>?
      </p>
    `;

    this.procesosComplementoService.alertaGeneralComplemento('¡Aviso!', ``, 'warning', true, true, html).then(result => {
      if (result.isConfirmed) {
        // NOTE: Comentado
        // this.cancelarSubidaArchivosExtender();
        this.mostrarNotificacionDocumentosRegistrados(hayArchivosPendientes);
        this.closeDialog('Cancelar');
      }

      if (result.isDenied || result.isDismissed) {
        this.mostrarNotificacionDocumentosCancelados();
      }
    });
  }

  cancelarSubidaArchivosExtender(): void {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestro: `${this.siniestroConsultado}`,
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.cancelarSubirArchivosExtender(request).subscribe({
      next: (value) => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos terminar de procesar la carga.' }));
      },
    })

  }

  mostrarNotificacionDocumentosCancelados(): void {
    const mensajeHTML = `
    <p style="text-align: left;">
      Se canceló el proceso para subir los archivos pendientes del siniestro.<br><br>
      <b>${this.siniestroConsultado}</b>, los puede subir más adelante abriendo la pantalla del expediente electrónico del siniestro
      y luego dando click en el botón Guardar.
    </p>
  `;
    this.procesosComplementoService.alertaGeneralComplemento('¡Aviso!', ``, 'warning', false, true, mensajeHTML).then(result => {
      if (result.isConfirmed || result.isDismissed) {
        this.closeDialog('Aceptar');
      }
    });
  }

  mostrarNotificacionDocumentosRegistrados(contadorArchivos: number): void {
    const mensajeHTML = `
    <p style="text-align: left;">
      Se registraron exitosamente <strong>${contadorArchivos}</strong> documento(s) para el siniestro.<br><br>
      <b>${this.siniestroConsultado}</b><br><br>
      Si faltaron archivos por subir, un proceso automatizado informará el problema al área de sistemas para su corrección.<br>
      Si es necesario, se comunicarán con usted.
    </p>
  `;
    this.procesosComplementoService.alertaGeneralComplemento('¡Aviso!', ``, 'warning', false, true, mensajeHTML).then(result => {
      if (result.isConfirmed || result.isDismissed) {
        this.closeDialog('Aceptar');
      }
    });
  }

  mostrarNotificacionDocumentosExtender(contadorArchivos: number): void {
    const mensajeHTML = `
    <p style="text-align: left;">
      Se registraron exitosamente los documento(s) para el siniestro.<br><br>
      <b>${this.siniestroConsultado}</b><br><br>
    </p>
  `;
    this.procesosComplementoService.alertaGeneralComplemento('¡Guardado!', ``, 'success', false, true, mensajeHTML).then(result => {
      if (result.isConfirmed || result.isDismissed) {
        this.closeDialog('Aceptar');
      }
    });
  }

  generaExpedienteElectronico() {
    const siniestroFormateado = this.procesosComplementoService.devolverSiniestro(this.siniestroConsultado);
    const request = {
      moneda: siniestroFormateado.moneda,
      ramo: siniestroFormateado.ramo,
      sramo: siniestroFormateado.sramo,
      oficina: siniestroFormateado.oficina,
      consecutivo: siniestroFormateado.consecutivo,
      anio: siniestroFormateado.anio,
      siniestro: `${this.siniestroConsultado}`,
    }

    this.store.dispatch(ActivarLoadingAction());
    this.complementoWebService.generaExpedienteElectronico(request).subscribe({
      next: (value) => {
        if (value.Exito && value.Resultado != null) {
          this.mostrarNotificacionDocumentosExtender(value.Resultado.ContadorArchivos ?? 0);
          // this.guardarArchivosPendientesDocumentum();
        } else {
          this.procesosComplementoService.alertaGeneralComplemento('Aviso', `Es posible que no se haya generado el expediente.`, 'warning', false, true);
        }
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
        this.store.dispatch(MostrarMensajeErrorAction({ titulo: 'Error', mensaje: 'No pudimos terminar de procesar la carga.' }));
      },
    })
  }

  precargaDocumentosDetalleDocumentum(tabIdex: number) {
    const datosTab = this.seccionesFotografias[tabIdex];
    this.store.dispatch(ActivarLoadingAction());
    const request = {
      tipo_movimiento: "Complemento Siniestros",
      referencia: this.siniestroConsultado,
      id_exp: String(datosTab.cve_docto),
    };
    this.documentumService.listAll(request).subscribe({
      next: (res) => {
        this.documentoGenerales = res ? res.data.filter(doc => {
          const { cveDocumento } = this.documentumService.procesarParametroIdentific(doc.attributes.identific, ["cveDocumento", "identificador"]);
          return datosTab.cve_docto == Number(cveDocumento);
        }).map((archivo) => {
          const { identificador } = this.documentumService.procesarParametroIdentific(archivo.attributes.identific, ["cveDocumento", "identificador"]);
          const encuentraNombre = datosTab.Fotografias.find(doc => Number(doc.rowid) == Number(identificador));
          return {
            ...archivo,
            ...encuentraNombre,
            objectId: archivo.objectId,
            link: archivo.link,
          }
        }) : [];
        this.seccionesFotografias[tabIdex].Fotografias = this.documentoGenerales;
      },
      complete: () => {
        this.store.dispatch(DesactivarLoadingAction());
      },
      error: (err) => {
        this.store.dispatch(DesactivarLoadingAction());
      }
    });
  }

  eliminaArchivoDocumentum(fotografia: Fotografia): Observable<any> {
    const documentoLista = this.documentoGenerales.find(doc => doc.rowid == fotografia.rowid);
    if (!documentoLista?.objectId) {
      return throwError(() => new Error('No se encontró objectId en Documentum'));
    }
    return this.documentumService.delete(documentoLista?.objectId);
  }

  guardarArchivosPendientesDocumentum() {
    const datosTab = this.seccionesFotografias;
    const documentosTodos = datosTab.reduce((acc, tab) => {
      const documentosTodos = tab.Fotografias.filter(fotografia => !fotografia.fotografia.includes("No_Disponible") && !this.documentoGenerales.some(doc => doc.rowid == fotografia.rowid));
      const documentosCreados = this.crearDocumentoDocumentm(this.siniestroConsultado, String(tab.cve_docto), documentosTodos);
      return [...acc, ...documentosCreados];
    }, []);
    if (documentosTodos.length > 0) {
      this.documentosSeccionComplemento.onArchivosValidados(documentosTodos, false);
      this.closeDialog('Aceptar');
    } else {
      this.mostrarNotificacionDocumentosExtender(0);
    }
  }
}
